import clientsIcon from '../media/puntos.png';
import coffeeIcon from '../media/cubo.png';
import codeIcon from '../media/puntero.png';
import yearsIcon from '../media/engrane.png';

const stats = [
  { id: 'clientes', icon: clientsIcon, value: '100', label: 'Clientes' },
  { id: 'cafe', icon: coffeeIcon, value: '3,500', label: 'Tazas de café' },
  { id: 'codigo', icon: codeIcon, value: '1,000,000', label: 'Líneas de código' },
  { id: 'anios', icon: yearsIcon, value: '10', label: 'Años' },
];

/**
 * Franja de métricas del home ("Nuestros números").
 *
 * El color de fondo de cada círculo lo asigna el CSS con :nth-child, por eso el
 * orden del arreglo importa: mover un elemento le cambia el color.
 */
const Stats = () => (
  <div className="statsSection">
    <h3>Nuestros números</h3>
    <p className="textBold">En estos 10 años</p>

    <div className="statsGrid">
      {stats.map(({ id, icon, value, label }) => (
        <div key={id}>
          <div className="statIcon">
            <img src={icon} alt="" />
          </div>
          <h4>{value}</h4>
          <p>{label}</p>
        </div>
      ))}
    </div>
  </div>
);

export default Stats;
